import { ExportItemEnum } from 'APIPackage/ImportExportModule/enums/ExportItemEnum';
import { IExportItem } from 'APIPackage/ImportExportModule/interfaces/IExportItem';
import { formatDate, formatDateLocale } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_FULL_FNS, DATE_FORMAT_ISO_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';

import { IExportRow } from '../interfaces/IExportRow';

export const mapDataToExportRow = (data: IExportItem[], isErknm: boolean): IExportRow[] => {
  return data.map(item => {
    let status;

    switch (item.status as ExportItemEnum) {
      case ExportItemEnum.NEW: {
        status = 'Новый';
        break;
      }
      case ExportItemEnum.DONE: {
        status = 'Выгрузка успешно сформирована';
        break;
      }
      case ExportItemEnum.IN_PROGRESS: {
        status = 'В процессе обработки';
        break;
      }
      case ExportItemEnum.ERROR: {
        status = 'Ошибка формирования выгрузки';
        break;
      }
      default: {
        status = item.status;
        break;
      }
    }

    return {
      ...item,
      uploadId: item.type === 'KNM' || item.type === 'KNM_PLAN' || item.type === 'PM' ? item.uploadId?.toString() : '—',
      status,
      created:
        item.created &&
        (isErknm
          ? formatDate({
              date: item.created,
              dateFormat: DATE_FORMAT_FULL_FNS,
              parseFormat: DATE_FORMAT_ISO_FNS,
            })
          : formatDateLocale({
              date: item.created,
              dateFormat: DATE_FORMAT_FULL_FNS,
              parseFormat: DATE_FORMAT_ISO_FNS,
            })),
      formed:
        item.formed &&
        (isErknm
          ? formatDate({
              date: item.formed,
              dateFormat: DATE_FORMAT_FULL_FNS,
              parseFormat: DATE_FORMAT_ISO_FNS,
            })
          : formatDateLocale({
              date: item.formed,
              dateFormat: DATE_FORMAT_FULL_FNS,
              parseFormat: DATE_FORMAT_ISO_FNS,
            })),
      type:
        isErknm && item.type === 'APPROVED_KNM_PLAN'
          ? UploadFileTypesEnum.APPROVED_KNM_PLAN_ERKNM
          : UploadFileTypesEnum[item.type as keyof typeof UploadFileTypesEnum] || item.type,
      'file.filename': item.filename,
    };
  });
};
